<template>
  <div class="details_form_item">
    <Form :model="dataModel" :label-width="130">
      <FormItem label="短信标题：">{{dataModel.sendTitle}}</FormItem>
      <FormItem label="短信接收方：">{{dataModel.reciveNumbers}}</FormItem>
      <FormItem label="发送表述：">{{dataModel.sendDescribtion}}</FormItem>
      <FormItem label="发送状态：">{{$common.getEnumDescription("SendFlag", dataModel.sendFlag)}}</FormItem>
      <FormItem label="发送成功时间：">{{dataModel.sendSuccesDate}}</FormItem>
      <FormItem label="发送内容：">{{dataModel.sendContent}}</FormItem>
    </Form>

    <div class="ml-5 mt-5 text-center modal-foter">
      <Button @click="returnBack">关 闭</Button>
    </div>
  </div>
</template>
<script>
export default {
  props: ["currentData"],
  components: {},
  data: function () {
    return {
      dataModel: {},
    };
  },

  mounted () {
    this.dataModel = this.currentData;
  },

  methods: {
    returnBack: function () {
      this.$emit("close");
    },
  },
};
</script>
<style scoped>
</style>